import { render, staticRenderFns } from "./BuyRegisterType2.vue?vue&type=template&id=78d5be1a&scoped=true&"
import script from "./BuyRegisterType2.vue?vue&type=script&lang=js&"
export * from "./BuyRegisterType2.vue?vue&type=script&lang=js&"
import style0 from "./BuyRegisterType2.vue?vue&type=style&index=0&id=78d5be1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5be1a",
  null
  
)

export default component.exports